import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { BsArrowRightCircle } from "react-icons/bs";

import Loader from '../../Loader/Loader';
import './Syllabus.css'

const SYLLABUS_URL = '/syllabus'

function Syllabus() {

  const [syllabus, setSyllabus] = useState('')

  useEffect(() => {
    async function getSyllabus() {
      try {
        const response = await axios.get(process.env.REACT_APP_DEPT_API + SYLLABUS_URL);
        setSyllabus(response.data);
      } catch (error) {
        console.error(error);
      }
    }
    getSyllabus()
  }, [])


  const getColor = (sem) => {
    if(sem === 1 || sem === 2)
      return '#D37775'
    else if(sem === 3 || sem === 4)
      return '#EFB16D'
    else if(sem === 5 || sem === 6)
      return '#5EB2CE'
    else if(sem === 7 || sem === 8)
      return '#60CE5E'
  }

  const sortedSyllabus = syllabus && syllabus.sort((a, b) => a.semester < b.semester ? -1 : 1)
    
  return (
    <div className='syllabus'>
        <div className='section__container'>
            <div className='section'>
                <h1 className='section__header'>Syllabus</h1>
                <p className='about__p'>
                  The Syllabus of the Computer Science Engineering Course is designed in a way that lets students explore their interests in core fields like Operating Systems, Compiler Design, Finite Automata Theory, and Computer Graphics, etc with proper guidance and careful assessment. These courses are interleaved with subjects from Humanities, Professional Ethics, Life Skills and Communication to instill them about their significance in personal and professional life. </p>
                <div className='syllabus_container'>
                  {sortedSyllabus ? sortedSyllabus.map((syl) => (
                    <div className='syl__year' key={syl.semester}>
                      <div className='syl_sem' data-aos="fade-up">
                        <h1 style={{background: getColor(syl.semester)}}>S{syl.semester}</h1>
                        <p style={{color: getColor(syl.semester)}}>KTU Syllabus of Semester {syl.semester}</p>
                        <a href={syl.link} target="_blank" rel="noreferrer">
                          <BsArrowRightCircle className='syl__icon'/>
                        </a>
                      </div>
                    </div>
                  )) : <Loader color="#AE9142" size={50}/>}
                </div>
                
            </div>
    
        </div>
    </div>
  )
}

export default Syllabus